window.dataLayer = window.dataLayer || [];

export default {
  pushEvent: (event) => {
    window.dataLayer.push(event);
  },
  createReservationFormSubmitEvent: (apartment) => {
    const isReservation = apartment.available;
    const address = apartment.location?.address;
    const type = apartment.features?.roomTypes;
    const size = `${apartment.sizeM2} m2`;
    return {
      event: "reservationFormSubmit",
      reservation: isReservation,
      apartment_house_company: apartment.housingCompanyName,
      address,
      type,
      size,
      selling_price: apartment.salesPrice,
      price: apartment.salesPriceUnencumbered,
    };
  },
};
